import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import InCallIcon from '../../icons/InCallIcon';
import ShareIcon from '../../icons/ShareIcon';
import CardButton from '../CardButton';
import ObligatoryIcon from "../../icons/ObligatoryIcon";
import RecommendedIcon from "../../icons/RecommendedIcon";
import mail from '../../other/config.json';
import translate from '../../other/translate.json';
import Tooltip from '@material-ui/core/Tooltip';
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import AbortRecall from '../../components/AbortRecall';
import FavoriteButton from '../Favorites/FavoriteButton';
import utils from '../../other/utils';

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

const CustomIconButton = withStyles((theme) => ({
  root: {
    // color: theme.palette.getContrastText(purple[500]),
    // backgroundColor: purple[500],
    color: '#BCBBD0',
    backgroundColor: '#FFFFFF',
    boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)',
    marginLeft: 8,
    // '&:hover': {
    //   backgroundColor: purple[700],
    // },
  },
}))(IconButton);

export default function ProdInsideCard(props) {
  const classes = useStyles();
  let { prod, SumAppsRecommended, SumAppsNeeded, rsbu, IsResearchMarket, countRecom, countNeeded } = props;
  const [snackbar, _snackbar] = useState([false, '']);
  const [ModalCallback, _ModalCallback] = useState(false);
  const lang = localStorage.getItem('language') || 'Ru';

  function closeSnackbar(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    _snackbar([false, '']);
  };

  function setAppProd(prod) {
    // let ProdBasketStorage = JSON.parse(localStorage.getItem('cartProd'));

    // if (ProdBasketStorage.some((element) => element === prod.ID) === true) {
    //   _prodBasket(ProdBasketStorage.filter(el_ => el_ !== prod.ID))
    //   localStorage.setItem('cartProd', JSON.stringify(ProdBasketStorage.filter(el_ => el_ !== prod.ID)))
    //   let arr_ = []
    //   appBasket.forEach(el => {
    //     if (prod['AppsIDsNeeded'] && prod['AppsIDsRecommended'] && prod['AppsIDsNeeded'].length + prod['AppsIDsRecommended'].length > 0 && prod['AppsIDsNeeded'].concat(`,${prod['AppsIDsRecommended']}`).includes(el)) { } else {
    //       arr_.push(el)
    //     }
    //   })
    //   _appBasket(union(arr_))
    //   localStorage.setItem('cartApp', JSON.stringify(union(arr_)))

    // } else {
    //   _prodBasket(ProdBasketStorage.concat([prod.ID]))
    //   localStorage.setItem('cartProd', JSON.stringify(ProdBasketStorage.concat([prod.ID])))
    //   if (prod['AppsIDsNeeded'] === null && prod['AppsIDsRecommended'] === null) {
    //   } else if (prod['AppsIDsNeeded'].length + prod['AppsIDsRecommended'].length > 0) {
    //     let need__ = prod['AppsIDsNeeded'].length > 0 ? prod['AppsIDsNeeded'].split(',') : []
    //     let recom__ = prod['AppsIDsRecommended'].length > 0 ? prod['AppsIDsRecommended'].split(',') : []
    //     _appBasket(appBasket.concat(need__.concat(recom__)))
    //     localStorage.setItem('cartApp', JSON.stringify(union(appBasket.concat(need__.concat(recom__)))))
    //   } else { }
    // }
    props.saveCollection(prod.ID, 'product', 'cart', [].concat(prod.AppsIDsNeeded.split(',').map(el => +el.trim()), prod.AppsIDsRecommended.split(',').map(el => +el.trim())));
  }

  let mailTo1 = `mailto:?subject=${mail['subjectShare']}&body=${encodeURIComponent(mail[`bodyShare_${lang}`]) + ' ' + window.location.href}`

  function showSnackbar(type, text) {
    if (type === 1) {
      _snackbar([true, text]);
      setAppProd(prod);
    } else {
      _snackbar([true, text]);
    }
  }

  const handleModalCallback = () => {
    _ModalCallback(!ModalCallback)
  }

  const renderFavoritesIcon = (row, isCart, productFavorite) => {
    let productInFavorite = productFavorite && productFavorite.includes(row.ID);
    let title = productInFavorite ? translate.Words[`RemoveFromFavorite${lang}`] : translate.Words[`AddToFavorite${lang}`];
    let fill = productInFavorite ? '#FFFFFF' : '#BCBBD0';
    let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'product', 'favorite', [].concat(row.AppsIDsNeeded.split(',').map(el => +el.trim()), row.AppsIDsRecommended.split(',').map(el => +el.trim()))) };
    let backgroundColor = productInFavorite ? '#EB505E' : '#FFF';
    return (
      <FavoriteButton fill={fill} title={title} onClick={onClick} boxShadow backgroundColor={backgroundColor} />
    )
  }

  const copyToClipboard = async () => {
    try {
      const permissions = await navigator.permissions.query({ name: "clipboard-write" })
      if (permissions.state === "granted" || permissions.state === "prompt") {
        await navigator.clipboard.writeText(mail[`linkShare_${lang}`] + ' ' + window.location.href);
        showSnackbar(2, translate.Words[`CopiedProductToClipboard_${lang}`]);
      } else {
        showSnackbar(2, translate.Words[`NotAccessClipboard_${lang}`]);
      }
    } catch (error) {
      showSnackbar(2, translate.Words[`ErrorCopyingClipboard_${lang}`] + error);
    };

    window.location.href = mailTo1;
  };

  const inCu = props.userCollection.inCu;

  const renderProdCurrency = (type, condition) => (
    inCu === '1'
      ?
      <CustomTooltip title={<span>
        {translate.Words[`CurrentRate_${lang}`]}
        {/* <br />{translate.Words[`NextRate_${lang}`]} */}
      </span>}>
        <Typography className={classes.Body2Medium} style={{ paddingLeft: 4 }}>
          {utils.getPriceItem(inCu, lang, 'elp')}
        </Typography>
      </CustomTooltip>
      :
      <Typography className={classes.Body2Medium} style={{ paddingLeft: 4 }}>
        {utils.getPriceItem(inCu, lang, 'elp')}
      </Typography>
  )

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography className={classes.Title3}>{translate.Words[`Applications_${lang}`]}  </Typography>
          </Grid>

          <Grid item>
            {renderFavoritesIcon(props.product, false, props.userCollection.productFavorite)}

            <CustomTooltip title={translate.Words[`ShareLink_${lang}`]}>
              <CustomIconButton aria-label={translate.Words[`ShareLink_${lang}`]} onClick={() => copyToClipboard()}>
                <ShareIcon fill='#BCBBD0' />
              </CustomIconButton>
            </CustomTooltip>

            <HtmlTooltip
              interactive
              title={
                !props.isAuth
                  ?
                  lang === 'Ru'
                    ?
                    <Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы отправить сообщение</Grid>
                    :
                    <Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to send message</Grid>
                  :
                  <Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`RequestACallback${lang}`]}</Grid>
              }
            >
              <span style={{ display: 'inline-block' }}>
                <CustomIconButton disabled={!props.isAuth} aria-label="delete" onClick={() => handleModalCallback()}>
                  <InCallIcon fill='#BCBBD0' />
                </CustomIconButton>
              </span>
            </HtmlTooltip>
          </Grid>
        </Grid>

        <Grid item container className={classes.PriceActionCntr}>
          <Grid container xl={12} lg={6} md={6} direction="row" justify="flex-start" alignItems="center" className={classes.PriceCntr}>
            {
              countNeeded > 0
                ?
                <React.Fragment>
                  <Grid item container direction="row" className={classes.priceContainer}>
                    <Grid item container direction="row" style={{ maxWidth: 230 }}>
                      <Grid item style={{ width: 31 }}>
                        <ObligatoryIcon fill={'#EB505E'} />
                      </Grid>

                      <Grid item>
                        <Typography className={classes.Caption1}>{translate.Words[`LicensingRequired${lang}`]}</Typography>
                      </Grid>
                    </Grid>

                    <Grid item>
                      <Typography className={classes.Caption1} style={{ color: '#24262A' }}>{countNeeded}</Typography>
                    </Grid>
                  </Grid>

                  <Grid item style={{ marginLeft: 31, padding: 0 }}>
                    <Typography className={classes.Body2Medium}>
                      {
                        SumAppsNeeded && SumAppsNeeded > 0
                          ?
                          parseFloat(SumAppsNeeded).toLocaleString('ru-RU', { maximumFractionDigits: 3 })
                          :
                          '0'
                      }
                    </Typography>
                  </Grid>

                  <Grid item>
                    {renderProdCurrency()}
                  </Grid>
                </React.Fragment>
                :
                null
            }

            {
              countRecom > 0//SumAppsRecommended && SumAppsRecommended > 0
                ?
                <React.Fragment>
                  <Grid item container direction="row" className={classes.priceContainer} style={{ paddingTop: 18 }}>
                    <Grid item container direction="row" style={{ maxWidth: 230 }}>
                      <Grid item style={{ width: 31 }}>
                        <RecommendedIcon fill={'#FE9D67'} />
                      </Grid>

                      <Grid item>
                        <Typography className={classes.Caption1}>{translate.Words[`RecommendedForLicensing${lang}`]}<br /> {rsbu}</Typography>
                      </Grid>
                    </Grid>

                    <Grid item>
                      <Typography className={classes.Caption1} style={{ color: '#24262A' }}>{countRecom}</Typography>
                    </Grid>
                  </Grid>

                  <Grid item style={{ marginLeft: 31, padding: 0 }}>
                    <Typography className={classes.Body2Medium}>
                      {
                        SumAppsRecommended && SumAppsRecommended > 0
                          ?
                          parseFloat(SumAppsRecommended).toLocaleString('ru-RU', { maximumFractionDigits: 3 })
                          :
                          translate.Words[`NotCharged${lang}`]
                      }
                    </Typography>
                  </Grid>

                  <Grid item>
                    {
                      SumAppsRecommended && SumAppsRecommended > 0
                        ?
                        renderProdCurrency()
                        :
                        null
                    }
                  </Grid>
                </React.Fragment>
                :
                ''
            }
          </Grid>

          <Grid container xl={12} lg={6} md={6} className={classes.ActionCntr}>
            {IsResearchMarket
              ?
              <CardButton
                text={translate.Words[`Prioritize${lang}`]}
                bgcolor={'#74D972'}
                shadow={'0px 6px 24px rgba(116, 217, 114, 0.4)'}
              />
              :
              <CardButton
                func={() => showSnackbar(1, props.userCollection.productBasket.includes(prod.ID) ? translate.Words[`DelToCartProd_${lang}`] : translate.Words[`AdtoCartProd_${lang}`])}
                text={props.userCollection.productBasket.includes(prod.ID) ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`]}
                bgcolor={'#8094FF'}
                shadow={'none'}
                mt={'0px'}
                p={0}
                icon={1}
              />
            }
          </Grid>
        </Grid>

        {/* второй этап <Grid style={{ marginTop: 32 }}>
          <Typography component="p" className={classes.Caption1} style={{color: '#81D39D', float: 'right'}}>
            Лицензировано
          </Typography>
        </Grid> */}
      </CardContent>

      <CardActions>
        {/* <Button size="small">Learn More</Button> */}
      </CardActions>

      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={snackbar[0]}
          autoHideDuration={3000}
          onClose={closeSnackbar}
        >
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            className={classes.snackbarPostroot}
          >
            <Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
              </svg>
            </Avatar>

            <Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
              {snackbar[1]}
            </Typography>
          </Grid>
        </Snackbar>
      </div>

      <AbortRecall
        isAuth={props.isAuth}
        usname={props.usname}
        prodID={props.prod.ID}
        ModalCallback={ModalCallback}
        setModalCallback={_ModalCallback}
        submit={'callback'}
      />
    </Card >
  );
}

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.87)',
    color: 'rgba(255, 255, 255, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    borderRadius: '8px',
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 400,
    padding: 12,
    opacity: 0.5,

    '& a': {
      color: 'rgba(255, 255, 255, 0.87)',
    }
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    boxShadow: 'none',
    padding: 40,
    maxHeight: 400,

    [theme.breakpoints.down(696)]: {
      padding: 0,
      backgroundColor: 'transparent'
    }
  },

  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },

  title: {
    fontSize: 14,
  },

  pos: {
    marginBottom: 12,
  },

  AppInsideCardCaption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#93919B'
  },

  AppInsideCardCaption2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#8987A2'
  },

  AppInsideCardCaption4: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '25px',
    color: '#24262A',
    opacity: 0.4
  },

  AppInsideCardTitle4: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  AppInsideCardBody2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#8987A2'
  },

  formControl: {
    height: 40,
    marginRight: 0
  },

  Title3: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#000000',

    [theme.breakpoints.down(696)]: {
      fontFamily: 'Cera CY',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '18px',
      lineHeight: '28px'
    }
  },

  Caption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#8987A2'
  },

  priceSecondary: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    color: '#8987A2'
  },

  Body2Medium: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#24262A',
    marginTop: 7
  },

  PriceActionCntr: {
    marginTop: 35,
    display: 'inline-flex',

    [theme.breakpoints.down(1702)]: {
      marginTop: 26,
    },

    [theme.breakpoints.down(1032)]: {
      marginTop: 38,
    },
  },

  PriceCntr: {
    margin: 0,
    paddingBottom: 24,

    [theme.breakpoints.between(1032, 1701)]: {
      paddingRight: 32,
    },

    [theme.breakpoints.between(696, 1032)]: {
      maxWidth: 340,
      margin: 'auto'
    },

    [theme.breakpoints.down(696)]: {
      maxWidth: "unset",
      paddingRight: 0,
      margin: "unset"
    },
  },

  ActionCntr: {
    [theme.breakpoints.down(1032)]: {
      maxWidth: 340,
      margin: 'auto'
    },
  },

  snackbarPostroot: {
    padding: 24,
    borderRadius: '16px',
    background: 'rgba(60, 60, 86, 0.9)',
  },

  priceContainer: {
    padding: 0,
    justifyContent: "space-between",
  },
}));